
import React, { PropTypes } from 'react';

import ArticleMeta from './ArticleMeta';
import './style.scss';

const ArticlePreview = props => {
  const { title, ...otherProps } = props;

  return (
    <div className="ArticlePreview">
      <h4>{title}</h4>

      <ArticleMeta {...otherProps} />

      {props.children}
    </div>
  );
};

ArticlePreview.propTypes = {
  children: PropTypes.element,
  title: PropTypes.string,
  articleUrl: PropTypes.string
};

export default ArticlePreview;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/ArticleOuter/Article/ArticlePreview/index.js
 **/